import Copy from 'assets/img/icons/copy.svg';
import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import LoadingCustom from 'components/layouts/loading/loading';
import { RegionType, DirectorateType } from 'components/types/backOffice/company';
import dayjs from 'dayjs';
import { useOuterClick } from 'providers/OutsideClick';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { useMemo, useState } from 'react';
import ModalRegion from '../modal';

import ModalActivityType from '../modal';

interface PropTypes {
  t: (e:string) => string
}

const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
    },
  },
};
const CustomTableMod = styled.div`
  [data-column-id="1"] {
    min-width: 10%;
    tex-align: left;
  }
  .rdt_TableBody {
    height: 500px;
    overflow: auto;
  }
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
`;
const ButtonCopyID = styled(Button)`
  width: 100%;
  width: 37px;
  height: 24px;
  float: right;
  background-color: #9aff5b;
`;

function Index(props:PropTypes) {
  const { t } = props;
  const [showModal, setShowModal] = useState(false);
  const [dataEdit, setDataEdit] = useState(null);
  const [id, setId] = useState(null);
  const [typeForm, setTypeForm] = useState('');
  const { list_region, keyRegion } = useSelector((state) => ({
    list_region: state?.organization?.list_region,
    keyRegion: state?.loading?.listKey?.companyRegion,
  }));

  const innerRef = useOuterClick((e) => {
    if (
      e?.srcElement?.className && (e.srcElement?.className === 'modal fade show'
            || e.srcElement?.className?.includes('cs_modal-bg'))
    ) {
      setShowModal(false);
      setId(null);
    }
  });

  const actionID = (id:string) => (
    <ButtonCopyID
      func={() => {
        navigator.clipboard
          .writeText(id)
          .then(() => {
            toast.success('ID Copied!');
          })
          .catch(() => {
            toast.error('ID Not Copied!');
          });
      }}
    >
      <span>
        <img src={Copy} alt="copy_id" />
      </span>
    </ButtonCopyID>
  );

  const actionEdit = (data: RegionType, i: number) => (
    <ButtonEdit
      icon="edit"
      func={() => {
        setShowModal(true);
        setTypeForm('edit');
        setId(i);
        setDataEdit(data);
      }}
    >
          &nbsp;&nbsp;
      {t('org.structure_view.modal.edit')}
    </ButtonEdit>
  );

  const columns = [
    {
      name: 'No',
      sortField: true,
      selector: (_, i) => i + 1,
      cellStyle: { verticalAlign: 'middle' },
      width: 'fit-content',
    },
    {
      name: 'ID',
      sortField: true,
      cell: (row) => actionID(row.region_id),
      headerStyle: {
        padding: '0px',
        justifyContent: 'start',
      },
      style: {
        padding: '0px',
        justifyContent: 'start',
      },
      cellStyle: { verticalAlign: 'middle' },
    },
    {
      name: t('company.name'),
      sortField: true,
      selector: (row) => row.name,
    },
    {
      name: t('board.desc'),
      sortField: true,
      selector: (row) => row.description,
    },
    {
      name: t('org.index_view.last_update'),
      sortField: true,
      selector: (row) => dayjs(row.updated_at).format('D MMM YYYY') ?? '-',
      center: true,
      width: '20%',
    },
    {
      name: t('org.employee.action'),
      sortField: true,
      style: {
        justifyContent: 'center',
      },
      center: true,
      selector: (row) => 'der',
      width: '15%',
      cell: (row, i) => actionEdit(row, i),
    },
  ];

  return (
    <>
      {showModal && (
        <ModalRegion
          innerRef={innerRef}
          modal={showModal}
          funcModal={setShowModal}
          ids={id}
          dataActivityType={dataEdit}
          funcId={() => setId}
          typeForm={typeForm}
          t={t}
        />
      )}
      <div
        className="tab-pane active position-relative"
        id="region_list"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        { keyRegion ? <LoadingCustom /> : (
          <>
            <div className="row">
              <div className="col-8">
                <h4 className="title">{t('wla.analytics.table.region')}</h4>
              </div>
              <div className="col-4">
                <ButtonMod
                  icon="create"
                  func={() => {
                    setShowModal(true);
                    setDataEdit(null);
                    setTypeForm('create');
                  }}
                >
                  &nbsp;&nbsp;
                  {t('board.add')}
                </ButtonMod>
              </div>
            </div>
            <CustomTableMod>
              <CustomTable
                columns={columns}
                data={list_region}
                customStyles={customStyles}
              />
            </CustomTableMod>
          </>
        )}
      </div>
    </>
  );
}

export default Index;
